'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
import UIIcon from '../icon/UIIcon';
import UIIconButton from './UIIconButton';
import omit from '../utils/underscore/omit';
var EXCLUDED_ICON_BUTTON_PROP_NAMES = ['children', 'use', 'truncate', 'truncateStringProps'];
var ICON_NAMES = {
  first: 'first',
  previous: 'left',
  next: 'right',
  last: 'last'
};
export default function UIStepperButton(_ref) {
  var iconName = _ref.iconName,
      rest = _objectWithoutProperties(_ref, ["iconName"]);

  return React.createElement(UIIconButton, Object.assign({}, rest, {
    use: "tertiary-light"
  }), React.createElement(UIIcon, {
    name: ICON_NAMES[iconName]
  }));
}
UIStepperButton.propTypes = Object.assign({}, omit(UIIconButton.propTypes, EXCLUDED_ICON_BUTTON_PROP_NAMES), {
  'aria-label': PropTypes.string.isRequired,
  iconName: PropTypes.oneOf(Object.keys(ICON_NAMES)).isRequired
});
UIStepperButton.defaultProps = Object.assign({}, omit(UIIconButton.defaultProps, EXCLUDED_ICON_BUTTON_PROP_NAMES));
UIStepperButton.displayName = 'UIStepperButton';